import { createStore, applyMiddleware, compose } from 'redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import thunkMiddleware from 'redux-thunk'
import { createBrowserHistory } from 'history'
import RBRestMiddleware from '../util/RBRestMiddleware'

import rootReducer from './reducers'

export const history = createBrowserHistory()
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export const store = createStore(
  connectRouter(history)(rootReducer),
  composeEnhancer(
    applyMiddleware(
      routerMiddleware(history),
      thunkMiddleware, RBRestMiddleware
    )
  )
)



// WEBPACK FOOTER //
// ./src/redux/store.js